const listaDeEquipes = (state) => {
    return state.items || [];
}

const loadingEquipe = (state) => {
    return state.buscando
}

const paginacao = (state) => state.paginacao || null

const listaDeUsuarios = (state) => {
    return state.usuarios || [];
}

const listaDeTarefas = (state) => {
    return state.tarefas || [];
}

const listaDeTodasTarefas = (state) => {
    return state.todasTarefas || [];
}

const equipeSelecionadaComUsuarios = (state) => {
    return state.selecionado || {}
}

const equipeSelecionadaComTarefas = (state) => {
    return state.selecionado || {}
}

export {
    loadingEquipe,
    listaDeEquipes,
    paginacao,
    listaDeUsuarios,
    equipeSelecionadaComUsuarios,
    listaDeTarefas,
    listaDeTodasTarefas,
    equipeSelecionadaComTarefas
}